export default {
	DATE: 'maskDate',
	DECIMAL: 'maskDecimal',
	DECIMAL_POSITIVE: 'maskDecimalPositive',
	EMAIL: 'maskEmail',
	INTEGER: 'maskInteger',
	INTEGER_POSITIVE: 'maskIntegerPositive',
	PHONE: 'maskPhone',
	ZIPCODE: 'maskZipCode',
};
